import React, { PureComponent } from "react";

interface ISVGPen2IconProps {
  className?: string;
  size?: string | number;
  fill?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGPen2Icon extends PureComponent<
  ISVGPen2IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 45}
        fill={fill || "currentColor"}
        style={style}
        width="32"
        height="32"
        viewBox="0 0 40 40"
      >
        {/* 검정색 연필 아이콘 (outline 스타일) */}
        <path
          fill="none"
          stroke="#8694B1"
          d="M21.145,6.781l9.311,9.311L10.238,36.31l-8.3.916A1.746,1.746,0,0,1,.01,35.3l.924-8.307ZM36.214,5.4,31.843,1.023a3.493,3.493,0,0,0-4.939,0L22.791,5.136,32.1,14.447l4.113-4.113A3.493,3.493,0,0,0,36.214,5.4Z" 
          transform="translate(0.001 -0.001)" 
          
          // fill="none"
          // stroke="currentColor"
        />
      </svg>
    );
  }
}
